import { Html } from "@react-three/drei";

const CanvasUiContainer = ({ children, ...props }) => {
  return (
    <Html calculatePosition={() => [0, 0]} zIndexRange={[999999998, 999999999]}>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          pointerEvents: "none",
          zIndex: 999999999,
        }}
      >
        {children}
      </div>
    </Html>
  );
};

export default CanvasUiContainer;
